var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPrimaryWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 80",
    style: {
      enableBackground: "new 0 0 128 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.47,18.12h-5.5v-1h5.5c1.1,0,2-0.9,2-2v-2.99c0-1.1-0.9-2-2-2h-5.5v-1h5.5c1.66,0,3,1.35,3,3v2.99 C76.48,16.77,75.13,18.12,73.47,18.12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.48,26.12h-5.5v-1h5.5c1.1,0,2-0.9,2-2v-3.01c0-1.1-0.9-2-2-2h-5.5v-1h5.5c1.65,0,3,1.34,3,3v3.01 C76.48,24.77,75.13,26.12,73.48,26.12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.97,26.12H53.48c-1.1,0-2-0.9-2-2V11.12c0-1.1,0.9-2,2-2h14.99l0,0.5v16.49L67.97,26.12z M53.48,10.12 c-0.55,0-1,0.45-1,1v12.99c0,0.55,0.45,1,1,1h14v-15H53.48z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.98,22.12h-6.5v-5h6.5c0.86,0,2.5,0.52,2.5,2.5S62.84,22.12,61.98,22.12z M56.48,21.12h5.5 c0.25,0,1.5-0.09,1.5-1.5s-1.25-1.5-1.5-1.5h-5.5V21.12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.98,18.12h-6.5v-5h6.5c0.86,0,2.5,0.52,2.5,2.5S62.84,18.12,61.98,18.12z M56.48,17.12h5.5 c0.25,0,1.5-0.09,1.5-1.5s-1.25-1.5-1.5-1.5h-5.5V17.12z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.74,36.72v0.8c0,2.3-0.7,3.78-2.27,4.51c1.89,0.74,2.62,2.43,2.62,4.8v1.82c0,3.46-1.82,5.31-5.34,5.31 h-5.54v-22.4h5.31C25.18,31.57,26.74,33.27,26.74,36.72z M19.74,40.69h1.38c1.31,0,2.11-0.58,2.11-2.37v-1.25 c0-1.6-0.54-2.3-1.79-2.3h-1.7V40.69z M19.74,50.77h2.02c1.18,0,1.82-0.54,1.82-2.21v-1.95c0-2.08-0.67-2.72-2.27-2.72h-1.57 V50.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.79,51.22V47.7c0-2.08-0.7-2.85-2.3-2.85h-1.22v9.12h-3.52v-22.4h5.31c3.65,0,5.22,1.7,5.22,5.15v1.76 c0,2.3-0.74,3.81-2.3,4.54c1.76,0.74,2.34,2.43,2.34,4.77v3.46c0,1.09,0.03,1.89,0.38,2.72h-3.58 C40.92,53.4,40.79,53.04,40.79,51.22z M37.27,41.65h1.38c1.31,0,2.11-0.58,2.11-2.37v-2.21c0-1.6-0.54-2.3-1.79-2.3h-1.7V41.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.51,41.01v3.2h-4.83v6.56h6.08v3.2h-9.6v-22.4h9.6v3.2h-6.08v6.24H59.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.62,53.97h-3.17v-22.4h4.42l3.62,13.41V31.57h3.14v22.4H75l-4.38-16.22V53.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.54,31.57v3.2h-3.68v19.2h-3.52v-19.2h-3.68v-3.2H95.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.68,31.32c3.46,0,5.34,2.05,5.34,5.63V48.6c0,3.58-1.89,5.63-5.34,5.63c-3.46,0-5.34-2.05-5.34-5.63 V36.95C101.34,33.36,103.22,31.32,106.68,31.32z M106.68,51.03c1.12,0,1.82-0.61,1.82-2.21v-12.1c0-1.6-0.7-2.21-1.82-2.21 c-1.12,0-1.82,0.61-1.82,2.21v12.1C104.86,50.42,105.56,51.03,106.68,51.03z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.58,60.18c0.38,0.41,0.58,1.03,0.58,1.87v0.53c0,0.62-0.1,1.11-0.3,1.46s-0.54,0.61-1.01,0.76 c1,0.28,1.5,1.08,1.5,2.4v0.94c0,0.85-0.21,1.5-0.63,1.95s-1.06,0.67-1.93,0.67h-2.58v-11.2h2.51 C54.57,59.57,55.19,59.77,55.58,60.18z M54.56,64c0.24-0.21,0.36-0.6,0.36-1.17v-0.66c0-0.5-0.1-0.87-0.29-1.11 s-0.51-0.36-0.94-0.36h-1.23v3.62h0.96C53.94,64.32,54.32,64.22,54.56,64z M54.79,69.27c0.21-0.25,0.32-0.63,0.32-1.15v-0.99 c0-0.61-0.12-1.04-0.37-1.29c-0.25-0.25-0.65-0.38-1.2-0.38h-1.09v4.18h1.33C54.24,69.64,54.58,69.51,54.79,69.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.71,60.21c0.43-0.5,1.07-0.75,1.91-0.75c0.84,0,1.48,0.25,1.92,0.75c0.44,0.5,0.66,1.19,0.66,2.06v5.79 c0,0.88-0.22,1.56-0.66,2.06c-0.44,0.5-1.08,0.75-1.92,0.75c-0.83,0-1.47-0.25-1.9-0.75c-0.44-0.5-0.66-1.19-0.66-2.06v-5.79 C61.06,61.4,61.28,60.71,61.71,60.21z M62.63,69.33c0.22,0.28,0.55,0.42,0.99,0.42c0.89,0,1.33-0.54,1.33-1.62v-5.92 c0-0.51-0.11-0.91-0.33-1.19c-0.22-0.28-0.55-0.42-1-0.42c-0.44,0-0.77,0.14-0.99,0.42c-0.22,0.28-0.34,0.68-0.34,1.19v5.92 C62.3,68.65,62.41,69.06,62.63,69.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.98,70.77h-1.18L73.05,65l-2.11-5.42h1.3l1.73,4.48l1.74-4.48h1.17L74.78,65l2.24,5.78H75.7l-1.86-4.83 L71.98,70.77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 83.48,
    y1: 65.12,
    x2: 111.48,
    y2: 65.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.48,65.62h-28c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h28c0.28,0,0.5,0.22,0.5,0.5 S111.75,65.62,111.48,65.62z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 16.48,
    y1: 65.12,
    x2: 44.98,
    y2: 65.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.98,65.62h-28.5c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h28.5c0.28,0,0.5,0.22,0.5,0.5 S45.25,65.62,44.98,65.62z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPrimaryWhite);
export default __webpack_public_path__ + "static/media/logo-primary-white.b3422d84bf97439bd1375f2b1e1c6a07.svg";
export { ForwardRef as ReactComponent };